import React from 'react';
import { Row, Col } from 'react-bootstrap';

import OrderEditContainer from '../containers/OrderEditContainer.jsx';
import OrderDetailEditContainer from '../containers/OrderDetailEditContainer.jsx';

const OrderFlowEditComponent = ({
    // state
    step1Class,
    step2Class,
    step1Display,
    step2Display
    // dispatch
}) => (
        <div>
            <Row style={{ marginLeft: 15, marginRight: 15 }}>
                <Col xs={12} sm={12} md={12}>
                    <ul className="nav nav-pills nav-justified thumbnail setup-panel">
                        <li className={step1Class}><a href="#step-1">
                            <p className="list-group-item-heading">Step 1</p>
                            <p className="list-group-item-text">新增訂單內容</p>
                        </a></li>
                        <li className={step2Class}><a href="#step-2">
                            <p className="list-group-item-heading">Step 2</p>
                            <p className="list-group-item-text">新增訂單明細</p>
                        </a></li>
                    </ul>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={12} md={12}>
                    <div id="addOrder" style={{ display: step1Display }}>
                        <OrderEditContainer />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={12} md={12}>
                    <div id="addOrderDetails" style={{ display: step2Display }}>
                        <OrderDetailEditContainer />
                    </div>
                </Col>
            </Row>
        </div>
    );

export default OrderFlowEditComponent;


// WEBPACK FOOTER //
// ./src/components/OrderFlowEditComponent.jsx